import React from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Link } from 'react-router-dom';
import '../../styles/login-register/login-register.scss';
import Grid from '@material-ui/core/Grid';
import HeaderAuth from '../includes/HeaderAuth';

//Milan Andrejic
import axios from 'Axios';
import { Redirect } from 'react-router';
import styled from 'styled-components';

const InputNotification = styled.span`
  text-align: right;
  text-decoration: none;
  color: red;
  font-size: 0.875rem;
  display: inline-block;
  padding: 0.5rem 0;
`;

(function(w) {
  w.URLSearchParams =
    w.URLSearchParams ||
    function(searchString) {
      var self = this;
      self.searchString = searchString;
      self.get = function(name) {
        var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
          self.searchString
        );
        if (results == null) {
          return null;
        } else {
          return decodeURI(results[1]) || 0;
        }
      };
    };
})(window);

class ChooseNewPassword extends React.Component {
  state = {
    showPassword: false,
    showConfirmPassword: false,
    password: '',
    confirmPassword: '',
    confirmPasswordErr: '',
    email: '',
    token: '',
    error: '',
    redirectToNextStep: false,
  };

  componentDidMount() {
    this.checkForResetExist();
  }

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };
  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPasssword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
  handleClickShowConfirmPasssword = () => {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  };
  handleBlurValidatePasswordConfirm = () => {
    if (this.state.password === this.state.confirmPassword) {
      this.setState({
        confirmPasswordErr: '',
        // disabledBtnEmail: true,
      });
    } else {
      this.setState({
        confirmPasswordErr: 'Check your entry, password do not match',
        // disabledBtnEmail: true,
      });
    }
  };

  checkForResetExist = () => {
    if (this.props.location.search.length) {
      const params = new URLSearchParams(this.props.location.search);
      const email = params.get('email');
      const token = params.get('resetTok');
      this.setState({
        email: email,
        token: token,
      });
    }
  };

  sendNewPssword = () => {
    if (this.state.password === '' || this.state.confirmPassword === '') {
      this.setState({ error: 'Both fields are required' });
      return;
    } else {
      this.setState({ error: '' });
      if (this.state.confirmPasswordErr === '') {
        this.resetPass();
      } else {
        console.log('something is wrong');
        return;
      }
    }
  };

  resetPass = () => {
    axios
      .post('account/choose_new_password', {
        newPassword: this.state.confirmPassword,
        resetToken: this.state.token,
      })
      .then(
        this.setState({
          password: '',
          confirmPassword: '',
          redirectToNextStep: true,
        })
      )
      .catch(error => {
        this.setState({ error: error.response.data });
      });
  };

  render() {
    if (this.state.redirectToNextStep) {
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: {
              finishMessage:
                'Password successfully reset! Log in with your new password!',
            },
          }}
        />
      );
    }
    return (
      <Grid spacing={0} container>
        <Grid
          className={'change_password_background b-entry-background'}
          item
          xs={12}
        >
          <HeaderAuth type="/login" />
          <Grid
            className="center-vertically"
            container
            alignItems={'center'}
            justify={'center'}
          >
            <Grid
              item
              xs={11}
              sm={5}
              lg={3}
              className="b-entry-credentials-wrapper"
            >
              <div className="b-entry-credentials-wrapper__text">
                <h3 className="b-entry-credentials-wrapper__text t-primary-24 t-color-w u-mrg-bot-30">
                  Choose new password
                </h3>
                <span className="b-entry-credentials-wrapper__text t-secondary-16 t-color-w">
                  You have requested to reset the password for:
                  {this.state.email}
                </span>
              </div>
              <FormControl fullWidth className="u-mrg-top-20">
                <InputLabel
                  htmlFor="password"
                  classes={{
                    // underline: 't-color-w',
                    root: 't-color-w',
                  }}
                >
                  Password
                </InputLabel>
                <Input
                  classes={{
                    underline: 'underline--c-white',
                    root: 't-color-w',
                  }}
                  id="adornment-password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  label="Password"
                  value={this.state.password}
                  onChange={this.handleChange('password')}
                  // onBlur={this.handleBlurValidatePasswordConfirm}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={this.handleClickShowPasssword}
                        onMouseDown={this.handleMouseDownPassword}
                      >
                        {this.state.showPassword ? (
                          <VisibilityOff style={{ color: '#fff' }} />
                        ) : (
                          <Visibility style={{ color: '#fff' }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>

              <FormControl fullWidth className="u-mrg-top-20">
                <InputLabel
                  htmlFor="confirm_password"
                  classes={{
                    // underline: 't-color-w',
                    root: 't-color-w',
                  }}
                >
                  Confirm Password
                </InputLabel>
                <Input
                  classes={{
                    underline: 'underline--c-white',
                    root: 't-color-w',
                  }}
                  id="adornment-confirm-password"
                  type={this.state.showConfirmPassword ? 'text' : 'password'}
                  label="Confirm Password"
                  value={this.state.confirmPassword}
                  onChange={this.handleChange('confirmPassword')}
                  onBlur={this.handleBlurValidatePasswordConfirm}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={this.handleClickShowConfirmPasssword}
                        onMouseDown={this.handleMouseDownPassword}
                      >
                        {this.state.showConfirmPassword ? (
                          <VisibilityOff style={{ color: '#fff' }} />
                        ) : (
                          <Visibility style={{ color: '#fff' }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <InputNotification>
                  {this.state.confirmPasswordErr}
                </InputNotification>
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                className="u-mrg-top-50 t-weight-b"
                onClick={this.sendNewPssword}
              >
                Set a new password
              </Button>
              <InputNotification>{this.state.error}</InputNotification>

              <p className="t-secondary-16 t-align-c u-mrg-top-50">
                <Link to="/login" className="link-bellow-button t-color-w">
                  Back to Login
                </Link>
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default ChooseNewPassword;
